import showToastBar from 'components/Common/ShowToast';
import Spinners from 'components/Common/Spinner';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { Row, Col, Card, CardBody, CardHeader, ModalHeader, ModalBody, Modal } from 'reactstrap';
import { createSelector } from 'reselect';
import { getBookingDocumentLoading } from 'store/actions';
import {
	deleteBookingDocumentAPI,
	downloadBookingConfirmationDocumentAPI,
	downloadBookingDocumentAPI,
	previewBookingDocumentAPI
} from 'store/bookings/helper';

const BookingDocuments = props => {
	const [getAllBookingDocuments, setGetAllBookingDocuments] = useState([]);
	const [downloadingDocumentId, setDownloadingDocumentId] = useState(null);
	const [isDownloadingDocument, setIsDownloadingDocument] = useState(false);
	// Document Preview
	const [showPreviewDocument, setShowPreviewDocument] = useState(false);
	const [previewDocumentUrl, setPreviewDocumentUrl] = useState(null);
	const [isPreviewDocumentLoading, setIsPreviewDocumentLoading] = useState(false);

	const [isDeleteingDocument, setIsDeleteingDocument] = useState(false);
	const [deleteDocumentId, setDeleteDocumentId] = useState(null);
	const [deleteModalShow, setDeleteModalShow] = useState(false);

	const [isBookingConfirmationDownloading, setIsBookingConfirmationDownloading] = useState(false);
	const [addBookingDocumentsFlag, setAddBookingDocumentsFlag] = useState(false);

	const BookingsProperties = createSelector(
		state => state.Bookings,
		bookings => ({
			isLoading: bookings.booking_document_loading,
			dataValue: bookings.booking_document_data
		})
	);

	const { isLoading, dataValue } = useSelector(BookingsProperties);

	const dispatch = useDispatch();

	useEffect(() => {
		console.log('props.bookingId', props.bookingId);
		props.bookingId &&
			typeof props.bookingId !== 'undefined' &&
			dispatch(getBookingDocumentLoading({ bookingId: props.bookingId }));
	}, [props.bookingId]);

	useEffect(() => {
		setGetAllBookingDocuments(dataValue);
	}, [dataValue]);

	const downloadDocumentFile = documentId => {
		setDownloadingDocumentId(documentId);
		setIsDownloadingDocument(true);
	};

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardHeader className="bg-primary">
							<div className="d-flex ">
								<div className="flex-grow-1">
									<h4 className="card-title text-white mt-1 font-size-12">
										Booking Documents ({getAllBookingDocuments?.length})
									</h4>
								</div>
							</div>
						</CardHeader>
						<CardBody>
							<Row>
								{isLoading ? (
									<Col lg={12} className="mb-4">
										{' '}
										<div className="mt-5">
											<Spinners setLoading={() => {}} />
										</div>
									</Col>
								) : (
									<div>
										<Col lg={12} className="mb-4">
											<div className="d-flex align-items-center table-responsive">
												<table className="table text-center table-bordered table-striped table-responsive">
													<thead>
														<tr>
															<th className="align-middle">Document Type</th>
															<th className="align-middle">Uploaded On</th>
															<th className="align-middle">Action</th>
														</tr>
													</thead>
													<tbody className="font-size-11 text-center">
														{getAllBookingDocuments.length > 0 &&
															getAllBookingDocuments?.map((item, index) => (
																<tr key={index}>
																	<td>
																		{item?.documentType}
																		{item?.documentName && (
																			<span className="font-size-10">
																				<br /> <i className="mdi mdi-file-document me-1"></i> {item?.documentName}
																			</span>
																		)}
																		{item?.documentsNotes && (
																			<span className="font-size-10">
																				<br /> <i className="mdi mdi-text me-1"></i> {item?.documentsNotes}
																			</span>
																		)}
																	</td>
																	<td>
																		{item?.uploadedon}
																		<br />
																		<i className="mdi mdi-calendar-clock me-1"></i>
																	</td>
																	<td>
																		<button
																			type="button"
																			className="btn btn-sm btn-info ms-2"
																			onClick={() => {
																				//	showPreviewDocumentModal(item?.documentId);
																			}}
																		>
																			<i className="mdi mdi-eye me-2"></i>
																			Preview
																		</button>
																	</td>
																</tr>
															))}
														{getAllBookingDocuments.length <= 0 && (
															<tr>
																<td colSpan="4" className="text-center">
																	No Document Found
																</td>
															</tr>
														)}
													</tbody>
												</table>
											</div>
										</Col>
									</div>
								)}
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>

			{showPreviewDocument && (
				<Modal
					isOpen={true}
					size={'xl'}
					toggle={() => setShowPreviewDocument(false)}
					backdrop={true}
					style={{ zIndex: 1061 }}
				>
					<ModalHeader toggle={() => setShowPreviewDocument(false)}>Preview</ModalHeader>
					<ModalBody className="mb-5">
						{isPreviewDocumentLoading ? (
							<Spinners className="mt-2" setLoading={() => {}} />
						) : (
							<>
								<iframe src={previewDocumentUrl} title="Preview" width="100%" height="700px"></iframe>
							</>
						)}
					</ModalBody>
				</Modal>
			)}
		</React.Fragment>
	);
};
export default BookingDocuments;
